import React from 'react'
import { dispatch } from '@rematch/core';

import { Button, Header, Modal, TextArea, Message } from 'semantic-ui-react';

class CreateMetaDataSchema extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            metaData: JSON.stringify(props.selectedPracticeLibrary.metaDataSchema, null, 2)
        }
    }

    componentWillMount() {

    }

    close = () => {
        this.props.handleOpenSchema(false);
        this.setState({ metaData: null })
    }

    updateSchema = (e, data) => {
        this.setState({ metaData: data.value, parse: true })
    }


    createSchema = () => {
        let dataArray = []

        if (this.state.parse) {
            dataArray = JSON.parse(this.state.metaData);
        } else {
            dataArray = this.state.metaData;
        }

        if (this.state.metaData) {
            let payload = {
                _id: this.props.selectedPracticeLibrary._id,
                name: this.props.selectedPracticeLibrary.name,
                data: {
                    metaDataSchema: dataArray
                }
            }
            dispatch.lifeCycle.updatePlaybook(payload);
            this.close()
        } else {

        }
    }

    handleSchema = (schema) => {
        this.setState({ metaData: schema, parse: false })
    }

    IsValidJSONString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    render() {
        return (
            <Modal
                open={this.props.openSchema}
                onClose={this.close}
                size='small'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Header content="Create Custom Attribute" />
                <Modal.Content>

                    <TextArea
                        value={this.state.metaData}
                        fluid
                        placeholder='Add valid json schema'
                        style={{ minHeight: "300px" }}
                        className="w_100"
                        onChange={(e, data) => this.updateSchema(e, data)} />
                </Modal.Content>
                <Modal.Actions>
                    {this.state.metaData && this.state.metaData.length !== 0 && !this.IsValidJSONString(this.state.metaData) ?
                        <Message className="bg-warning"
                            style={{
                                float: "left",
                                padding: "8px",
                                width: "calc(100% - 200px)",
                                textAlign: "left"
                            }}
                            content='Please validate Json to enable button'
                        /> : null}
                    <Button
                        className="button-submit float-right"
                        id='createSchema'
                        disabled={!this.IsValidJSONString(this.state.metaData)}
                        onClick={this.createSchema}>
                        {this.props.selectedPracticeLibrary.metaData && this.props.selectedPracticeLibrary.metaData.length === 0 ? "Create" : "Update"}
                    </Button>
                    <Button
                        className="button-cancel"
                        id='cancelSchema'
                        onClick={this.close}>
                        Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default CreateMetaDataSchema